import CircularProgress from '@mui/material/CircularProgress';
import { LoaderWrapper } from './styles';
import { useTranslation } from 'react-i18next';
import { type CSSProperties } from 'react';

type Props = {
  text?: string;
  style?: CSSProperties;
};

function Loader({ text, style }: Props) {
  const { t } = useTranslation('web', { keyPrefix: 'components.loader' });

  return (
    <LoaderWrapper style={style}>
      <CircularProgress sx={{ color: 'var(--primary)' }} />
      <h2>{text ?? t('text')}</h2>
    </LoaderWrapper>
  );
}

export default Loader;
